import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios"
const { useGeneralContext } = require("../../contexts/GeneralContext");

const Register = () => {
        const [first_name, setFirstName] = useState("");
        const [last_name, setLastName] = useState("");
        const [email, setEmail] = useState("");
        const [school, setSchool] = useState("");
        const [position, setPosition] = useState("");
        const [schoolType, setSchoolType] = useState("");
        const [postcode, setPostcode] = useState("");
        const [error, setError] = useState("");

        const navigate = useNavigate();

        const generals = useGeneralContext();

        const register = async (first_name, last_name, email, school, position, school_type, school_postcode) => {
                try {
                        const res = await axios.post("/api/teachers/register", {
                                first_name, last_name, email, school_name: school, position, school_type, school_postcode
                        }, {
                                headers: {
                                        'Content-Type': 'application/json'
                                },
                                withCredentials: true
                        },);

                        navigate("/login", { state: { showRegisterSuccess: true } });
                } catch (err) {
                        setError("Something went wrong. Please try again.");
                }
        };

        const handleRegister = () => {
                if (!first_name || !last_name || !email || !school || !position || !schoolType || !postcode) {
                        setError("Please complete all fields.");
                } else {
                        setError("");
                        register(first_name, last_name, email, school, position, schoolType, postcode);
                };
        }

        return (
                <div className="auth-content">
                        <div className="auth-content-title">Create a teacher account</div>
                        <div className="auth-content-subtitle">
                                Please create a new account for {generals.YEAR}. After signing up you will receive a teacher code.
                        </div>
                        {error && <div className="error-message">{error}</div>}
                        <div className="auth-form">
                                <div className="split-label-group">
                                        <div className="label">First Name</div>
                                        <div className="label">Last Name</div>
                                </div>
                                <div className="split-input-group">
                                        <input type="text" className="input" placeholder="Jane" onChange={(e) => { setFirstName(e.target.value) }} />
                                        <input type="text" className="input" placeholder="Smith" onChange={(e) => { setLastName(e.target.value) }} />
                                </div>
                                <div className="split-label-group">
                                        <div className="label">Your Email</div>
                                        <div className="label">Your Position</div>
                                </div>
                                <div className="split-input-group">
                                        <input className="input" placeholder="jane@school.com" onChange={(e) => { setEmail(e.target.value) }} />
                                        <input className="input" placeholder="CS Teacher" onChange={(e) => { setPosition(e.target.value) }} />
                                </div>
                                <div className="label">School Name</div>
                                <input className="input" placeholder="School name" onChange={(e) => { setSchool(e.target.value) }} />
                                <div className="split-label-group">
                                        <div className="label">School Type</div>
                                        <div className="label">School Postcode</div>
                                </div>
                                <div className="split-input-group">
                                        <select className="input" onChange={(e) => setSchoolType(e.target.value)}>
                                                <option value="" disabled selected>Select</option>
                                                <optgroup label="State schools & colleges">
                                                        <option value="state_secondary">State Secondary (non-selective)</option>
                                                        <option value="grammar_school">Grammar School (selective)</option>
                                                        <option value="sixth_form_school">Sixth Form (school-based)</option>
                                                        <option value="sixth_form_college">Sixth Form College (state)</option>
                                                        <option value="fe_college">FE College (state, includes 16–19)</option>
                                                </optgroup>

                                                <optgroup label="Independent schools & colleges">
                                                        <option value="independent_secondary">Independent Secondary</option>
                                                        <option value="independent_sixth_form_college">Independent Sixth Form College</option>
                                                </optgroup>

                                                <optgroup label="Special & alternative provision">
                                                        <option value="special_school">Special School (KS4/KS5)</option>
                                                        <option value="ap_pru">Alternative Provision / PRU (KS4/KS5)</option>
                                                </optgroup>

                                                <optgroup label="Other">
                                                        <option value="other_education">Other Education (charity, youth org, STEM hub)</option>
                                                </optgroup>
                                        </select>
                                        <input className="input" placeholder="AB12 3CD" onChange={(e) => { setPostcode(e.target.value) }} />
                                </div>
                                <div className="form-button" onClick={handleRegister}>
                                        <span>
                                                Create account
                                        </span>
                                </div>
                                <div className="auth-alt-text">
                                        Already have an account? <Link to="/login" className="auth-link">Sign in</Link>
                                </div>

                                {/* 
                                
                                To add:
                                School type
                                School postcode
                                
                                
                                
                                */}
                        </div>
                </div>
        );
};

export default Register;